import React, { useMemo } from "react";
import { Alert, AlertIcon, AlertDescription, Box, Text, HStack, Badge, CloseButton } from "@chakra-ui/react";
import { useConfig } from "@/app/providers/ConfigProvider.jsx";

const CHECKS = [
  // GHL checks
  { key: "calendarId", label: "Calendar ID", check: (c) => !!c.calendarId },
  { key: "pipelineId", label: "Pipeline ID", check: (c) => !!c.pipelineId },
  { key: "oppCFMap", label: "Field Mapping", check: (c) => (c.oppCFMap && Object.keys(c.oppCFMap).length > 3) },
  // Universal checks
  { key: "mealTimes", label: "Meal Times", check: (c) => {
    const mt = c.mealTimes;
    if (!mt || typeof mt !== "object") return false;
    if (Array.isArray(mt)) return mt.length > 0;
    return !!(mt.breakfast || mt.lunch || mt.dinner);
  }},
];

export default function ConfigHealthCheck() {
  const { config } = useConfig();
  const [dismissed, setDismissed] = React.useState(false);

  const failures = useMemo(() => {
    return CHECKS.filter(c => !c.check(config));
  }, [config]);

  if (dismissed || failures.length === 0) return null;

  return (
    <Alert status="warning" variant="left-accent" mb={3}>
      <AlertIcon />
      <Box flex="1">
        <AlertDescription>
          <Text fontSize="sm" fontWeight="bold" mb={1}>
            Missing configuration ({failures.length} item{failures.length > 1 ? "s" : ""})
          </Text>
          <HStack spacing={2} flexWrap="wrap">
            {failures.map(f => (
              <Badge key={f.key} colorScheme="orange" variant="subtle">{f.label}</Badge>
            ))}
          </HStack>
          <Text fontSize="xs" color="gray.600" mt={1}>
            Go to Settings to complete your setup.
          </Text>
        </AlertDescription>
      </Box>
      <CloseButton position="absolute" right={2} top={2} onClick={() => setDismissed(true)} />
    </Alert>
  );
}
